<template>
  <div class="mt_140">

    <ccMenu ref="cc_menu"></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container ">
      <div class="row">

        <!-- coluna 1 principal -->
        <div class="col-md-8">

          <div class="row mb-3">
            <div class="col-12">
              <span class="text_24 text_branco text_bold">{{ torneio.nome }}</span> &nbsp; <span
                class="text_24 text_verde">: <span class="text_bold">R${{ formatarMoeda(torneio.prize) }}</span> </span>
            </div>
          </div>

          <div class="row" style="margin-bottom:8px;">
            <div class="col-2">
              <div class="text_13 text_verde text_bold">COMEÇA EM:</div>
              <div class="text_25 text_laranja text_bold">{{ tempo_regressivo }}</div>
            </div>
            <div class="col-10"
              style="background-color:#E4E4E40D; border-radius: 8px; border: 1px solid #6666660D; padding: 16px;">
              <span class="text_cinza">Entrada:</span> <span class="text_branco text_bold">R$
                {{ formatarMoeda(torneio.taxa_entrada) }}</span> &nbsp;
              <span class="text_cinza">Re-entrada:</span> <span
                class="text_branco text_bold">{{ torneio.max_reentrada }}</span> &nbsp;
              <span class="text_cinza">Participantes / Max Participantes:</span> <span
                class="text_branco text_bold">{{ torneio.qtd_aposta }}/{{ torneio.max_pessoa }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-12 pt-3" style="background:#171A28 0% 0% no-repeat padding-box; border-radius:12px;">

              <!-- JOGOS ------------------>
              <div class="row mb-4">
                <div class="col-12">

                  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="false">

                    <div class="row" id="box_jogo">
                      <div class="col-1">
                        <img :src='"../../assets/image/seta_esquerda.svg"' class="float-end"
                          data-bs-target="#carouselExampleIndicators" data-bs-slide="prev" width="25px"
                          style="transform: rotate(90deg); margin-top: 29px;">
                      </div>

                      <div class="col-10">
                        <div class="carousel-inner">

                          <div class="carousel-item active">
                            <div class="row text_cinza">
                              <div class="col-md-4" v-for="(jogo, key) in jogos"
                                v-on:click.prevent="select_jogo(jogo.id)">

                                <div v-if="(key < 3)" class="jogo"
                                  v-bind:class="{ jogo_active: jogo.check == 1, jogo_marcado: jogo.marcado == 1 }">
                                  <div class="text_11 text_branco mb-3">
                                    <img :src="jogo.pais_logo" data-bs-target="#carouselExampleIndicators"
                                      data-bs-slide="prev" width="15px">
                                    {{ jogo.pais_nome }}
                                    <p class="text_cinza text_11"> {{ jogo.liga_nome.substring(0, 24) }}
                                      <span v-if="jogo.liga_nome.length > 24">...</span>
                                    </p>
                                  </div>
                                  <div class="text_10 mb-1">
                                    <img v-bind:src="jogo.localteam_logo" class="image" :title='"localteam_logo"'>
                                    <span class="text_11 text_branco">{{ jogo.time1_nome }}</span>
                                  </div>
                                  <div class="text_10 mb-3">
                                    <img v-bind:src="jogo.visitorteam_logo" class="image" :title='"visitorteam_logo"'>
                                    <span class="text_11 text_branco">{{ jogo.time2_nome }}</span>
                                  </div>
                                  <div class="text_10 text-end mb-1">{{ timestamp_dataBR(jogo.dt_inicio_timestamp, 4) }}
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                          <div class="carousel-item" v-for="grupo in grupo_slide">
                            <div class="row text_cinza">
                              <div class="col-md-4" v-for="(jogo, key) in jogos"
                                v-on:click.prevent="select_jogo(jogo.id)">
                                <div v-if="key >= slide_inicio(grupo) && key <= slide_fim(grupo)" class="jogo"
                                  v-bind:class="{ jogo_active: jogo.check == 1, jogo_marcado: jogo.marcado == 1 }">
                                  <div class="text_11 text_branco mb-3">
                                    <img :src="jogo.pais_logo" data-bs-target="#carouselExampleIndicators"
                                      data-bs-slide="prev" width="15px">
                                    {{ jogo.pais_nome }}
                                    <p class="text_cinza text_11"> {{ jogo.liga_nome.substring(0, 24) }}
                                      <span v-if="jogo.liga_nome.length > 24">...</span>
                                    </p>

                                  </div>
                                  <div class="text_10 mb-1">
                                    <img v-bind:src="jogo.localteam_logo" class="image" :title='"localteam_logo"'>
                                    <span class="text_11 text_branco">{{ jogo.time1_nome }}</span>
                                  </div>
                                  <div class="text_10 mb-3">
                                    <img v-bind:src="jogo.visitorteam_logo" class="image" :title='"visitorteam_logo"'>
                                    <span class="text_11 text_branco">{{ jogo.time2_nome }}</span>
                                  </div>
                                  <div class="text_10 text-end mb-1">{{ timestamp_dataBR(jogo.dt_inicio_timestamp, 4) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div class="col-1">
                        <img :src='"../../assets/image/seta_esquerda.svg"' data-bs-target="#carouselExampleIndicators"
                          data-bs-slide="next" width="25px" style="transform: rotate(270deg); margin-top: 29px;">
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <!-- JOGOS: FIM -->

              <!-- mercado_opcao --------->
              <div class="row mb-5"
                style="background-color: #171A28; max-height:500px; padding-bottom: 60px; overflow:auto;">
                <div class="col-12 mb-4">

                  <div class="box_jogo" v-for="(jogo, j) in jogos" v-if="jogo.id == jogo_id">
                    <section id="mercado_opcao" v-for="(mercado, m) in jogos[j].mercado"
                      v-if="mercado.mercado_id < 9 || (mercado.mercado_id == 9 && [501, 503].includes(user.id))">

                      <div class="row">
                        <div class="col-12">
                          <div
                            v-bind:class="{ desabilite_opcoes: qtd_mercado_selecionado_pelo_usuario >= torneio.qtd_mercado_obrigatorio }">
                            <div class="text_cinza text_12"
                              style="background-color:#333366; text-align:left; margin-top:13px; border:1px solid #333366; border-radius:5px; padding:5px;">
                              <span class="text_bold text_branco"> {{ mercado.mercado_nome }} </span>
                              <!--
                                    <span class="float-end" style="cursor:pointer; text-decoration: underline;" @click="dupli(mercado.id)">cd 
                                      Super Aposta &nbsp;
                                      <img :src='"../../assets/image/flame.svg"' width="10px" v-if="mercado.dupli == 1">
                                    </span>
                                    -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row"
                        v-bind:class="{ desabilite_opcoes: qtd_mercado_selecionado_pelo_usuario >= torneio.qtd_mercado_obrigatorio }"
                        style="padding: 0px 7px 0px 7px;">
                        <div class="col-4" style="padding:0px;" v-for="(op, o) in jogos[j].mercado[m].opcao"
                          @click="select_opcao(op.id, mercado.mercado_id, jogo.id)">
                          <div class="row card_opcao" v-bind:class="{ card_opcao_selecionado: op.check == 1 }">
                            <div class="col-8 text_10" style="padding:0; border:0;"
                              v-bind:class="{ text_preto: op.check == 1 }">{{ traducao_opcao(op.nome) }}</div>
                            <div class="col-4 text_10 text_bold text-end" style="padding:0; border:0;"
                              v-bind:class="{ text_preto: op.check == 1, text_laranja: op.check != 1 }">{{ op.ponto }}</div>
                          </div>
                        </div>
                      </div>

                    </section>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
        <!-- coluna 1 principal: FIM -->

        <!-- coluna 2 principal -->
        <div class="col-md-4">

          <div class="col-12"
            style="background:#99AEE433; height:57px; border-radius:12px 12px 0px 0px; text-align:center; padding:10px 0 0 0;">
            <div class="text_15 text_bold text_branco">ESCOLHA {{ torneio.qtd_mercado_obrigatorio }} PALPITES</div>
            <div class="text_13 text_verde">ESCOLHA MAIS
              {{ qtd_mercado_selecionado_pelo_usuario }}/{{ torneio.qtd_mercado_obrigatorio }} PALPITES</div>
          </div>

          <!-- <div class="col-md-12" style="background:#E4E4E40D; border-radius:12px; text-align:center; padding:10px; height: 730px; overflow: scroll;"> -->
          <div class="col-md-12"
            style="background:#E4E4E40D; border-radius:12px; text-align:center; padding:10px; height: 530px; overflow-y: auto;">

            <div class="col-12 text_13 text_cinza btn_limpar_tudo mb-3" @click="deletar_todas_opcoes()">Limpar Tudo
            </div>

            <section id="apostas_selecionadas">
              <div v-for="opcao of opcoes_escolhidas" class="card text-center"
                style="border:1px solid #333366; border-radius:5px; margin-bottom:10px;">
                <div class="text_13 text_laranja"
                  style="height:32px; background-color: #333366; text-align:left; padding:5px 0 0 12px;">
                  {{ opcao.jogo_time1_nome }} x {{ opcao.jogo_time2_nome }}
                </div>
                <div class="card-body" style="height:37px; background-color: #171A28; padding: 10px;">
                  <div class="row">
                    <div class="col-9 text_branco text_12">
                      <div class="text-start" @click="dobre_o_ponto(opcao.opcao_id)">
                        <span>{{ opcao.mercado_nome }}</span> : <span
                          class="text_bold">{{ traducao_opcao(opcao.opcao_nome) }}</span>
                      </div>
                    </div>
                    <div class="col-3 text_branco text_12">
                      <div class="text-end" @click="deletar_opcao(opcao.opcao_id)">
                        {{ opcao.opcao_ponto }}
                        <img :src='"../../assets/image/delete.png"' class="imagem" alt="Responsive image"
                          :title='"sokkerduel"' width="10px" style="margin: 0px 0px 0px 5px;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </div>


          <div v-if="qtd_mercado_selecionado_pelo_usuario < torneio.qtd_mercado_obrigatorio"
            class="btn w-100 alerta_de_falta">
            FALTA {{ torneio.qtd_mercado_obrigatorio - qtd_mercado_selecionado_pelo_usuario }} PALPITES PARA ENTRAR NO
            TORNEIO
          </div>

          <button v-if="qtd_mercado_selecionado_pelo_usuario == torneio.qtd_mercado_obrigatorio" type="submit"
            class="btn btn-success w-100" @click="editar_aposta()">
            SALVAR BILHETE E ENTRAR
          </button>


        </div>
        <!-- coluna 2 principal: FIM -->

      </div>
    </div>

    <!----layout3-------------------->
    <div v-show="layout3"
      style="opacity: 1; position: fixed; top: 0; right: 0; bottom: 0; left: 0; background-color: #000000E3;  z-index: 5; display: flex; justify-content: center; align-items: center;">
      <div class="container">
        <div class="row">
          <div class="col-md-4 offset-md-4">
            <div class="card card_opcoes">
              <div class="card-body">

                <div class="row mb-5 p-2">
                  <div class="col-2 p-0">
                    <img :src='"../../assets/image/check.svg"' alt="Responsive image" :title='"sokkerduel"' width="100%"
                      class="pt-3 pe-2">
                  </div>
                  <div class="col-10">
                    <div class="text_14 text_bolder text_branco text_bold">{{ torneio.nome }}</div>
                    <div class="text_14 text_bolder text_cinza text_bold mb-3">{{ torneio.descricao_pagamento }}</div>
                    <div class="text_12 text_bolder text_branco text_bold"> TUDO PRONTO! </div>
                    <div class="text_12 text_laranja"> AGORA É SECAR SEUS ADVERSÁRIOS</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button v-if="torneio.tipo_id > 1"
                      class="btn btn-success btn-sm text_bold text_11 text_verde w-100 mb-2"
                      @click="perguntar_modal_mensagem(torneio.id)"> FAZER MAIS UMA REENTRADA
                    </button>
                    <router-link to="/meu_torneio"
                      class="btn btn-outline-success btn-sm text_bold text_11 text_verde w-100 mb-2">
                      IR PARA MEUS TORNEIOS
                    </router-link>
                    <router-link to="/home/torneio/0"
                      class="btn btn-outline-success btn-sm text_bold text_11 text_verde w-100 mb-2">
                      ENTRAR EM OUTRO TORNEIO
                    </router-link>
                    <router-link :to="{ name: 'minha_aposta_ws_redis', params: { torneio_id: torneio.id } }"
                      class="btn btn-outline-success btn-sm text_bold text_11 text_verde w-100 mb-2">
                      IR PARA DETALHES DESSE TORNEIO
                    </router-link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!----layout 3: fim---------------------->

    <ccDetalheTorneio ref="cc_detalhe_torneio"></ccDetalheTorneio>
    <ccMensagem ref="cc_mensagem" @evento_teste="resposta_modal_mensagem"></ccMensagem>
    <ccMensagemTravaOpcao ref="cc_mensagem_trava_opcao" @evento_trava_opcao="resposta_modal_mensagem">
    </ccMensagemTravaOpcao>

    <ccFooter></ccFooter>
  </div>
</template>


<script>
import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccMensagem from '../cc_geral/mensagem_editar_aposta.vue'
import ccMensagemTravaOpcao from '../cc_geral/mensagem_trava_opcao.vue'
import ccAlert from '../cc_geral/cc_alert.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccDetalheTorneio from '../cc_geral/cc_detalhe_torneio_modal.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data() {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //variaveis
      aposta_id: 0,
      torneio_id: 0,
      jogo_id: 0,
      agora: null,
      grupo_slide: 3,
      tempo_regressivo: 0,
      user_id: 0,
      qtd_selecionado: 0,
      qtd_mercado_obrigatorio: 0,
      qtd_mercado_selecionado_pelo_usuario: 0,
      opcao_id_selecionada_no_momento: 0,

      //array
      bloco: [],
      torneio: {},
      jogos: [],
      confirmar_jogo: [],
      opcoes_escolhidas: [],
      escolha_jogo: [],
      your_bet: [
        { i: 1, titulo: "Vencedor", preenchido: true },
        { i: 2, titulo: "Vencedor - 1º tempo", preenchido: true },
        { i: 3, titulo: "Gols", preenchido: true },
        { i: 4, titulo: "Gols 1º Tempo", preenchido: true },
        { i: 5, titulo: "Ambos marcam?", preenchido: true },
        { i: 6, titulo: "Ambos marcam- 1º tempo?", preenchido: true },
        { i: 7, titulo: "Escanteios", preenchido: true },
        { i: 8, titulo: "Escanteios 1º Tempo", preenchido: true },
      ],

      coluna1: false,
      coluna2: false,
      coluna3: false,
      coluna4: false,

      layout1: true,
      layout2: false,
      layout3: false,
    }
  },

  components: { ccMenu, ccMensagem, ccMensagemTravaOpcao, ccAlert, ccLoading, ccDetalheTorneio, ccFooter },

  created() {
    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted() {

    let a = JSON.parse(localStorage.getItem("user"));

    this.loading = true;

    if (a == null) {
      this.user = {}
      // alert('usuario nao logado')
    } else {
      this.user = a
    }

    this.aposta_id = this.$route.params.aposta_id;

    this.inicio()

    this.start_time()

    this.chamar_tela_coluna2()

  },

  methods: {

    inicio() {
      //pegue e monte o super bloco
      this.loading = true;
      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.get(this.base_url_api + 'aposta/' + this.aposta_id + '/frm_editar', header)
        .then(response => {

          this.bloco = response.data.resp

          this.get_torneio()

          this.get_jogo()

          this.monte_confirmar_jogo()

          this.get_opcoes_escolhidas()

          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    get_torneio() {

      var self = this;
      const dtFormat1 = new Intl.DateTimeFormat('sv-SE', {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
        timeZone: this.user.timezone,
      });

      let agora = Date.now()
      let seg = 0;
      let min = 0;
      let hora = 0;
      var dif = 0;

      var obj = {};
      for (var i = 0; i <= this.bloco.length - 1; i++) {
        obj = {
          id: this.bloco[i].id,
          nome: this.bloco[i].nome,
          sumario: this.bloco[i].sumario,
          tipo_id: this.bloco[i].tipo_id,
          qtd_aposta: this.bloco[i].qtd_aposta,
          taxa_entrada: this.bloco[i].taxa_entrada,
          max_reentrada: this.bloco[i].max_reentrada,
          dt_inicio: this.bloco[i].dt_inicio,
          dt_termino_timestamp: this.bloco[i].dt_termino_timestamp,
          status: this.bloco[i].status,
          tipo: this.bloco[i].tipo,
          prize: this.bloco[i].prize,
          estrutura_nome: this.bloco[i].estrutura_nome,
          min_pessoa: this.bloco[i].min_pessoa,
          max_pessoa: this.bloco[i].max_pessoa,
          porc_casa: this.bloco[i].porc_casa,
          qtd_mercado_obrigatorio: this.bloco[i].qtd_mercado_obrigatorio,
          descricao_pagamento: this.bloco[i].descricao_pagamento,
          dif: ((this.bloco[i].dt_inicio_timestamp * 1000) - agora) / 1000,
        }

        //trava - se usuario for diferente
        if (this.bloco[i].user_id != this.user.id) {
          alert('Alert! Usuário diferente!');
          self.$router.push({ path: '/meu_torneio/historico' });
          return;
        }

        //trava - se torneio nao esta em aberto
        if (this.bloco[i].status != 1) {
          alert('Torneio não está mais aberto!');
          self.$router.push({ path: '/meu_torneio/historico' });
          return;
        }

        //trava - se torneio for do tipo turbo 
        if (this.bloco[i].tipo_id == 4) {
          alert('Torneio turbo não permitido para edição.');
          self.$router.push({ path: '/meu_torneio/historico' });
          return;
        }

        document.title = obj.nome + ': R$' + obj.prize + ' - SokkerDuel';

      }
      this.torneio = obj;

      //atualize balance no menu
      this.atualize_menu()
    },

    // JOGO ---------------------------------------------
    get_jogo() {
      this.jogos = this.bloco[0].jogo

      //quantos blocos de 3 jogos sao?

      if (this.bloco[0].jogo.length == 1) { this.grupo_slide = 0 }
      if (this.bloco[0].jogo.length == 2) { this.grupo_slide = 0 }
      if (this.bloco[0].jogo.length == 3) { this.grupo_slide = 0 }

      if (this.bloco[0].jogo.length == 4) { this.grupo_slide = 1 }
      if (this.bloco[0].jogo.length == 5) { this.grupo_slide = 1 }
      if (this.bloco[0].jogo.length == 6) { this.grupo_slide = 1 }

      if (this.bloco[0].jogo.length == 7) { this.grupo_slide = 2 }
      if (this.bloco[0].jogo.length == 8) { this.grupo_slide = 2 }
      if (this.bloco[0].jogo.length == 9) { this.grupo_slide = 2 }

      if (this.bloco[0].jogo.length == 10) { this.grupo_slide = 3 }
      if (this.bloco[0].jogo.length == 11) { this.grupo_slide = 3 }
      if (this.bloco[0].jogo.length == 12) { this.grupo_slide = 3 }

      if (this.bloco[0].jogo.length == 13) { this.grupo_slide = 4 }
      if (this.bloco[0].jogo.length == 14) { this.grupo_slide = 4 }
      if (this.bloco[0].jogo.length == 15) { this.grupo_slide = 4 }

      if (this.bloco[0].jogo.length == 16) { this.grupo_slide = 5 }
      if (this.bloco[0].jogo.length == 17) { this.grupo_slide = 5 }
      if (this.bloco[0].jogo.length == 18) { this.grupo_slide = 5 }

      if (this.bloco[0].jogo.length == 19) { this.grupo_slide = 6 }
      if (this.bloco[0].jogo.length == 20) { this.grupo_slide = 6 }
      if (this.bloco[0].jogo.length == 21) { this.grupo_slide = 6 }

      if (this.bloco[0].jogo.length == 22) { this.grupo_slide = 7 }
      if (this.bloco[0].jogo.length == 23) { this.grupo_slide = 7 }
      if (this.bloco[0].jogo.length == 24) { this.grupo_slide = 7 }

      if (this.bloco[0].jogo.length == 25) { this.grupo_slide = 8 }
      if (this.bloco[0].jogo.length == 26) { this.grupo_slide = 8 }
      if (this.bloco[0].jogo.length == 27) { this.grupo_slide = 8 }

      if (this.bloco[0].jogo.length == 28) { this.grupo_slide = 9 }
      if (this.bloco[0].jogo.length == 29) { this.grupo_slide = 9 }
      if (this.bloco[0].jogo.length == 30) { this.grupo_slide = 9 }

      this.select_jogo(this.jogos[0].id)
    },

    select_jogo(jogo_id) {
      this.jogo_id = jogo_id

      for (var i = 0; i <= this.jogos.length - 1; i++) {

        this.jogos[i].check = 0;

        if (parseInt(this.jogos[i].id) == parseInt(jogo_id)) {
          this.jogos[i].check = 1;
        }
      }
    },

    // MERCADO/OPCOES ---------------------------------
    select_opcao(opcao_id, mercado_id, jogo_id) {
      // console.log(opcao_id + ' - ' + mercado_id + ' - ' + jogo_id )

      //check na opcao
      var opcao_nome = ''
      for (var j = 0; j <= this.jogos.length - 1; j++) {
        for (var m = 0; m <= this.jogos[j].mercado.length - 1; m++) {

          //limpeza de opcoes do mercado
          if (this.jogos[j].mercado[m].mercado_id == mercado_id && this.jogos[j].id == jogo_id) {
            for (var o = 0; o <= this.jogos[j].mercado[m].opcao.length - 1; o++) {
              this.jogos[j].mercado[m].opcao[o].check = 0;
              this.jogos[j].mercado[m].check = 0;
            }
          }

          if (opcao_id != this.opcao_id_selecionada_no_momento) {
            for (var o = 0; o <= this.jogos[j].mercado[m].opcao.length - 1; o++) {
              if (parseInt(this.jogos[j].mercado[m].opcao[o].id) == parseInt(opcao_id)) {
                this.jogos[j].mercado[m].opcao[o].check = 1;
                this.jogos[j].mercado[m].check = 1;
                opcao_nome = this.jogos[j].mercado[m].opcao[o].nome
              }
            }
          }

        }
      }

      this.opcao_id_selecionada_no_momento = opcao_id
      this.get_opcoes_escolhidas()


      //trava de opcao selecionada
      //verifique se a opcao pode ser selecionada
      // console.log(jogo_id+' - '+mercado_id+' - '+opcao_id+' - '+opcao_nome)

      let escolhidas = this.opcoes_escolhidas;
      let itemEncontrado = null;
      let alerta = false;

      if (mercado_id == 2 && opcao_nome == 'DRAW') {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 4 && item.opcao_nome === 'Under 0.5';
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (mercado_id == 4 && opcao_nome == 'Under 0.5') {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 2 && item.opcao_nome === 'DRAW';
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (mercado_id == 6 && opcao_nome == 'YES') {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 5 && item.opcao_nome === 'YES';
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (mercado_id == 6 && opcao_nome == 'YES') {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 4 && (item.opcao_nome === 'Over 1.5' || item.opcao_nome === 'Over 2.5');
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (mercado_id == 5 && opcao_nome == 'YES') {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 6 && item.opcao_nome === 'YES';
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (mercado_id == 4 && (opcao_nome == 'Over 1.5' || opcao_nome == 'Over 2.5')) {
        itemEncontrado = escolhidas.find(item => {
          return item.jogo_id === jogo_id && item.mercado_id === 6 && item.opcao_nome === 'YES';
        });
        if (itemEncontrado) {
          alerta = true
          this.deletar_opcao(opcao_id)
        }
      }

      if (alerta == true) {
        var obj = {
          cor: 1,
          titulo:
            "Para que o torneio tenha uma dinamica com mais habilidade, <br> você não pode selecionar essas opções conjuntas: Ambas 1º Tempo: SIM não pode Mais 1.5 1º Tempo / Mais  2.5 1º Tempo Ambas 1º Tempo: SIM não pode Ambas: SIM Menos 0.5 1º Tempo  não pode Empate 1º Tempo",
          texto: null,
          btn1_ativo: false,
          btn1_cor: 1,
          btn1_texto: null,
          btn1_link: '#',
          btn1_link_next: true,
          btn2_ativo: true,
          btn2_cor: 2,
          btn2_texto: 'Voltar',
          btn2_link: null,
          btn2_link_next: true,
        }
        this.$refs.cc_mensagem_trava_opcao.receber_dados(obj);
      }


    },

    //duplicar opcao do mercado
    dupli(mercado_id) {
      for (var j = 0; j <= this.jogos.length - 1; j++) {
        for (var m = 0; m <= this.jogos[j].mercado.length - 1; m++) {
          this.jogos[j].mercado[m].dupli = 0;
          if (this.jogos[j].mercado[m].id == mercado_id) {
            this.jogos[j].mercado[m].dupli = 1;
          }
        }
      }
      this.get_opcoes_escolhidas()
    },

    //ESCOLHIDAS -----------------------------------------
    get_opcoes_escolhidas() {
      var obj = {};
      var aux = this.bloco[0].jogo
      this.opcoes_escolhidas = [];

      // if(this.qtd_mercado_selecionado_pelo_usuario < this.torneio.qtd_mercado_obrigatorio){

      for (var j = 0; j <= aux.length - 1; j++) {
        for (var m = 0; m <= aux[j].mercado.length - 1; m++) {
          for (var o = 0; o <= aux[j].mercado[m].opcao.length - 1; o++) {

            if (aux[j].mercado[m].opcao[o].check == 1) {
              obj = {
                jogo_id: aux[j].id,
                jogo_time1_nome: aux[j].time1_nome,
                jogo_time2_nome: aux[j].time2_nome,
                mercado_id: aux[j].mercado[m].mercado_id,
                dupli: aux[j].mercado[m].dupli,
                mercado_nome: aux[j].mercado[m].mercado_nome,
                opcao_id: aux[j].mercado[m].opcao[o].id,
                opcao_nome: aux[j].mercado[m].opcao[o].nome,
                opcao_ponto: aux[j].mercado[m].opcao[o].ponto,
                opcao_check: aux[j].mercado[m].opcao[o].check,
              }


              // let trava = 0
              // let escolhida = this.opcoes_escolhidas

              // for (var e = 0; e <= escolhida.length-1;  e++){
              //   if(escolhida[e].mercado_id == 2 && escolhida[e].opcao_nome == 'DRAW'){

              //       alert( escolhida[e].mercado_id +' '+ escolhida[e].opcao_nome )
              //       trava = 1

              //   }else{
              //       trava = 0

              //   }
              // }

              // if(trava == 0){
              this.opcoes_escolhidas.push(obj);
              // }
            }

          }
        }
      }

      // }

      this.qtd_mercado_selecionado_pelo_usuario = this.opcoes_escolhidas.length

      if (this.qtd_mercado_selecionado_pelo_usuario >= this.torneio.qtd_mercado_obrigatorio) {
        this.show_layout2()
      }

      //se usuario nao escolheu nada, amostre as opções
      if (this.qtd_mercado_selecionado_pelo_usuario == 0) {
        this.show_layout1()
        this.chamar_tela_coluna1()
      }
    },

    deletar_opcao(opcao_id) {
      var aux = this.bloco[0].jogo
      for (var j = 0; j <= aux.length - 1; j++) {
        for (var m = 0; m <= aux[j].mercado.length - 1; m++) {
          for (var o = 0; o <= aux[j].mercado[m].opcao.length - 1; o++) {

            if (aux[j].mercado[m].opcao[o].id == opcao_id) {
              aux[j].mercado[m].opcao[o].check = 0
            }

          }
        }
      }

      this.get_opcoes_escolhidas()
    },

    deletar_todas_opcoes() {
      var aux = this.bloco[0].jogo
      for (var j = 0; j <= aux.length - 1; j++) {
        for (var m = 0; m <= aux[j].mercado.length - 1; m++) {
          for (var o = 0; o <= aux[j].mercado[m].opcao.length - 1; o++) {
            aux[j].mercado[m].opcao[o].check = 0
          }
        }
      }

      this.opcoes_escolhidas = []
      this.qtd_mercado_selecionado_pelo_usuario = 0

      this.show_layout1()
      this.chamar_tela_coluna1()
    },

    chamar_tela_coluna1() {
      this.coluna1 = true
      this.coluna2 = false
      this.coluna3 = false
      this.coluna4 = false
    },

    chamar_tela_coluna2() {
      this.coluna1 = false
      this.coluna2 = true
      this.coluna3 = false
      this.coluna4 = false
    },

    chamar_tela_coluna3() {
      this.coluna1 = false
      this.coluna2 = false
      this.coluna3 = true
      this.coluna4 = false
    },

    // INICIALIZACAO ---------------------------------------------------------
    monte_confirmar_jogo() {
      /*
        esta nova tabela é usada para confirmar as opões dos jogos depois
        que o usuario escolher todas as opçoes de um jogo.
      */
      var obj = {};
      for (var i = 0; i <= this.bloco[0].jogo.length - 1; i++) {
        obj = {
          id: this.bloco[0].jogo[i].id,
          fixture_id: this.bloco[0].jogo[i].fixture_id,
          time1_nome: this.bloco[0].jogo[i].time1_nome,
          time2_nome: this.bloco[0].jogo[i].time2_nome,
          habilitar_para_confirmar: 0,
          confirmado_pelo_usuario: 0,
        };
        this.confirmar_jogo.push(obj);
      }
    },

    // FUNCOES DE VERIFICACAO ---------------------------------------------------
    verifique_se_todas_opcoes_estao_marcadas(bloco_jogo) {
      // console.log(bloco_jogo)
      //verifique se todos os mercados estao escolhido as opçoes

      var cont_opcao = 0;
      var aux = 0;

      for (var j = 0; j <= bloco_jogo.length - 1; j++) {

        cont_opcao = 0
        for (var m = 0; m <= bloco_jogo[j].mercado.length - 1; m++) {

          aux = 0;
          for (var o = 0; o <= bloco_jogo[j].mercado[m].opcao.length - 1; o++) {

            if (bloco_jogo[j].mercado[m].opcao[o].check == 1) {
              cont_opcao++;
              aux = 1;
            }

          }

          if (aux == 1) {
            bloco_jogo[j].mercado[m].check = 1;
          } else {
            bloco_jogo[j].mercado[m].check = 0;
          }

        }

        if (cont_opcao == 8) {
          bloco_jogo[j].marcado = 1;

          //habilite o confirmar_jogo:habilitar
          for (var i = 0; i <= this.confirmar_jogo.length - 1; i++) {
            if (this.confirmar_jogo[i].id == bloco_jogo[j].id) {
              this.confirmar_jogo[i].habilitar_para_confirmar = 1
            }
          }

        } else {
          bloco_jogo[j].marcado = 0;

          //habilite o confirmar_jogo:habilitar
          for (var i = 0; i <= this.confirmar_jogo.length - 1; i++) {
            if (this.confirmar_jogo[i].id == bloco_jogo[j].id) {
              this.confirmar_jogo[i].habilitar_para_confirmar = 0
              this.confirmar_jogo[i].confirmado_pelo_usuario = 0
            }
          }

        }

      }

      //bloco_jogo[0].marcado = 1;

      return bloco_jogo;
    },

    //SAVE EDITAR ------------------------------------------------------------------
    editar_aposta() {
      var marcou = true;

      if (marcou == true) {
        this.loading = true;
        var self = this;

        var body = {
          aposta_id: this.aposta_id,
          user_id: this.user.id,
          tor_id: this.torneio.id,
          aposta: this.opcoes_escolhidas,
        };

        this.loading = true;
        var header = { 'headers': { 'x-access-token': this.user.access_token, } };
        axios.post(this.base_url_api + 'aposta/editar/save', body, header)
          .then(response => {

            if (response.data.resp.erro == null) {
              // alert(response.data.resp.msg);
              this.show_layout3()
            } else {
              alert(response.data.resp.erro);
            }

            this.loading = false;

          })
          .catch(e => {
            this.errors.push(e);
            alert(e)
          });
      }
    },

    //FUNCOES ----------------------------------------------------------------
    converte_tempo(diferenca) {
      let hor = Math.trunc(diferenca / 3600);
      let min = Math.trunc(diferenca % 3600 / 60);
      let s = Math.trunc(diferenca % 60)
      hor = (hor <= 9) ? '0' + hor : hor;
      min = (min <= 9) ? '0' + min : min;
      s = (s <= 9) ? '0' + s : s;

      return hor + ":" + min + ":" + s
    },

    // TIMERS -----------------------------------------------------------
    start_time() {
      this.timer_torneio_horario = setInterval(function () {

        this.torneio.dif = this.torneio.dif - 1;
        this.tempo_regressivo = this.converte_tempo(this.torneio.dif)

      }.bind(this), 1000);
    },

    stop_time() {
      clearInterval(this.timer_torneio_horario);
    },

    show_layout1() {
      this.layout1 = true
      this.layout2 = false
      this.layout3 = false
    },

    show_layout2() {
      this.layout1 = false
      this.layout2 = true
      this.layout3 = false
      this.chamar_tela_coluna2()
    },

    show_layout3() {
      this.layout1 = false
      this.layout2 = false
      this.layout3 = true
    },

    //************** entrar na aposta ***************** */
    perguntar_modal_mensagem(id) {
      this.torneio_id = id;

      this.layout3 = false

      var body = { user_id: this.user.id, torneio_id: this.torneio_id, };

      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.post(this.base_url_api + 'aposta/autorizacao', body, header)
        .then(response => {
          let m = response.data
          // usuario_bloqueado
          // dinheiro_insuficiente
          // torneio_iniciado
          // max_reentrada_atingido
          // max_aposta_atingido
          // tempo_aposta_esgotado

          if (m.status == 'success') {

            //maximo de reentrada e existem apostas vazias
            if (m.resp.erro == 'max_reentrada_atingido' && m.resp.aposta_check_vazia_count > 0) {
              var obj = {
                cor: 2,
                titulo: 'MAXIMO DE REENTRADA ATINGIDO',
                texto: 'Voce tem apostas vazias finalize agora!',
                btn1_ativo: true,
                btn1_cor: 2,
                btn1_texto: 'EDITAR APOSTA',
                btn1_link: '/torneio/' + this.torneio_id,
                btn1_link_next: true,
                btn2_ativo: false,
                btn2_cor: null,
                btn2_texto: null,
                btn2_link: null,
                btn2_link_next: true,
              }
              this.$refs.cc_mensagem.receber_dados(obj);
            }

            //maximo de reentrada e todas as apostas feitas
            if (m.resp.erro == 'max_reentrada_atingido' && m.resp.aposta_check_vazia_count == 0) {
              var obj = {
                cor: 3,
                titulo: 'MAXIMO DE REENTRADA ATINGIDO',
                texto: 'Voce já fez as reentradas no torneio!',
                btn1_ativo: true,
                btn1_cor: 3,
                btn1_texto: 'DETALHES DO TORNEIO',
                btn1_link: '/torneio/' + this.torneio_id,
                btn1_link_next: true,
                btn2_ativo: true,
                btn2_cor: 1,
                btn2_texto: 'ENTRAR EM OUTRO',
                btn2_link: '/home/torneio/0',
                btn2_link_next: true,
              }
              this.$refs.cc_mensagem.receber_dados(obj);
            }

            //tudo certo para apostar sem apostas vazias
            if (m.resp.erro == null && m.resp.aposta_check_vazia_count == 0) {
              var obj = {
                cor: 1,
                titulo: 'ATENÇÃO',
                texto: 'Depois que entrar só poderá editar e não cancelar',
                btn1_ativo: true,
                btn1_cor: 1,
                btn1_texto: 'OK, CRIAR APOSTA',
                btn1_link: '#',
                btn1_link_next: false,
                btn2_ativo: true,
                btn2_cor: 2,
                btn2_texto: 'NÃO, SAIR',
                btn2_link: '#',
                btn2_link_next: false,
              }
              this.$refs.cc_mensagem.receber_dados(obj);
            }

            //tudo certo para apostar com apostas vazias
            if (m.resp.erro == null && m.resp.aposta_check_vazia_count > 0) {
              var obj = {
                cor: 1,
                titulo: 'VOCÊ TEM APOSTA VAZIAS',
                texto: 'Você deseja reentrada ou editar sua aposta?',
                btn1_ativo: true,
                btn1_cor: 1,
                btn1_texto: '+1 REENTRADA',
                btn1_link: '#',
                btn1_link_next: false,
                btn2_ativo: true,
                btn2_cor: 3,
                btn2_texto: 'EDITAR APOSTA',
                btn2_link: '/torneio/' + this.torneio_id,
                btn2_link_next: true,
              }
              this.$refs.cc_mensagem.receber_dados(obj);
            }

            if (
              m.resp.erro == 'usuario_bloqueado' || m.resp.erro == 'dinheiro_insuficiente' || m.resp.erro == 'torneio_iniciado' ||
              m.resp.erro == 'max_aposta_atingido' || m.resp.erro == 'tempo_aposta_esgotado'
            ) {
              var obj = {
                cor: 1,
                titulo: m.resp.erro,
                texto: null,
                btn1_ativo: true,
                btn1_cor: 1,
                btn1_texto: 'VOLTAR',
                btn1_link: '/torneio/' + this.torneio_id,
                btn1_link_next: true,
                btn2_ativo: false,
                btn2_cor: 3,
                btn2_texto: null,
                btn2_link: null,
                btn2_link_next: true,
              }
              this.$refs.cc_mensagem.receber_dados(obj);
            }

          } else {
            alert('error')
          }

        })
        .catch(e => {

          if (e.response.status == 401) {
            var obj = {
              cor: 1,
              titulo: 'Para apostar precisa está logado!',
              texto: 'Faça o login!!',
              btn1_ativo: true,
              btn1_cor: 1,
              btn1_texto: 'ACESSAR',
              btn1_link: '/login',
              btn1_link_next: true,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'CANCELAR',
              btn2_link: '#',
              btn2_link_next: false,
            }
            this.$refs.cc_mensagem.receber_dados(obj);
          }

        });

    },

    resposta_modal_mensagem(variable) {
      if (variable) {
        this.montar_aposta_temporaria()
      }
    },

    montar_aposta_temporaria() {
      this.loading = true
      var body = { torneio_id: this.torneio.id, }
      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.post(this.base_url_api + 'aposta/save/temp', body, header)
        .then(response => {

          // console.log( response.data )

          if (response.data.resp.erro == null) {
            window.location.href = process.env.BASE_LOCAL + "#/palpite/" + response.data.resp.aposta_id + "/editar"
            window.location.reload()
          }
          // else{
          //   let te = response.data.resp.erro;
          //   this.$refs.cc_alert.receber_dados(te);
          // }

          this.loading = false
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });

    },
    //************** entrar na aposta fim ***************** */

    show_detalhe_torneio(torneio_id) {
      this.$refs.cc_detalhe_torneio.receber_dados(torneio_id);
    },

  }

}
</script>

<style scoped>
  .box1 {
    background-color: #101324;
    border-radius: 20px;
  }

  .box2 {
    background-color: #d1d1d1;
  }


  /*titulo*/
  #box_titulo {
    padding: 10px 0 0px 0;
  }

  #box_titulo .titulo {
    color: #afb0b5;
    font-size: 25px;
    font-weight: bolder;
  }

  #box_titulo .titulo .titulo_verde {
    color: #448900;
  }

  #box_titulo .link_detalhes {
    font-size: 12px;
    color: white;
    text-decoration: underline;
    cursor: pointer;
    text-align: right;
  }



  /*live*/
  #box_live {
    padding: 5px 0 0px 0;
  }

  #box_live .live {
    color: #448900;
    font-size: 11px;
    font-weight: bolder;
  }

  #box_live .hora {
    color: orange;
    font-size: 25px;
    font-weight: bolder;
  }

  #box_live .detalhes {
    color: #ccc;
    font-size: 12px;
  }

  #box_live .detalhes .bold {
    font-weight: bolder;
    color: #fff;
    font-size: 18px;
  }

  #box_live .caracteristicas {
    border-radius: 9px;
    background-color: #232736;
    padding-top: 15px;
  }


  /* JOGO ------------------------------------------------*/
  #box_jogo .jogo {
    position: relative;
    border: 1px solid #99AEE44D;
    border-radius: 10px;
    padding: 10px 10px 10px 10px;
    color: #99AEE480;
    cursor: pointer;
  }

  #box_jogo .jogo .image {
    width: 25px;
    height: 25px;
    opacity: 0.8;
  }

  #box_jogo .jogo:hover {
    background: #99AEE426 0% 0% no-repeat padding-box;
    border: 1px solid #70707026;
    border-radius: 10px;
  }

  #box_jogo .jogo_active {
    background-color: #99AEE480;
  }

  #box_jogo .jogo_marcado {
    /*background-color: #5cb70d; */
    /* border: solid 1px #5cb70d; */
    background: #99AEE47F 0% 0% no-repeat padding-box;
    border: 1px solid #707070;
    border-radius: 10px;
  }

  #box_jogo .topo_do_jogo {
    position: absolute;
    width: 20px;
    top: 0;
    right: 0;
  }



  /*  MERCADO/OPCAO --------------------------  */

  #mercado_opcao {
    margin-bottom: 20px;
  }

  #mercado_opcao .card_mercado {
    background-color: #171a28;
    color: #fff;
    padding: 10px 10px 10px 10px;
    margin-bottom: 5px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: bolder;
  }

  #mercado_opcao .card_opcao {
    background-color: #24283B;
    color: #fff;
    padding: 5px 14px 0px 14px;
    cursor: pointer;
    border-radius: 5px;
    margin: 5px;
    font-size: 12px;
    height: 27px;
  }

  #mercado_opcao .card_opcao:hover {
    background: #45495E 0% 0% no-repeat padding-box;
    border: 1px solid #0066001A;
    border-radius: 4px;
    color: #000;
  }

  #mercado_opcao .card_opcao_selecionado {
    background-color: #5CB70D;
    color: #000;
  }

  #mercado_opcao .card_mercado_azul {
    background-color: #333366;
  }

  .box_jogo {
    /* border: solid; */
    /*height: 650px;*/
    /*overflow:scroll;*/
  }

  #mercado_opcao .desabilite_opcoes {
    pointer-events: none;
    opacity: 0.2;
  }


  /*apostas_selecionadas -----------------------------------------------*/

  .btn_limpar_tudo {
    cursor: pointer;
    text-align: right;
    margin-bottom: 5px;
    text-decoration: underline;
  }

  .btn_salvar_aposta {
    height: 41px;
    background-color: #5CB70D80;
    color: #ffffff80;
    font-size: 15px;
    font-family: myFontBold;
  }

  .alerta_de_falta {
    padding-top: 8px;
    height: 41px;
    background-color: #ffffff4D;
    color: #ffffff4D;
    font-size: 13px;
  }

  .card_opcoes {
    background: transparent linear-gradient(68deg, #071A24 0%, #000000 100%) 0% 0% no-repeat padding-box;
    box-shadow: 5px 3px 6px #000000C7;
    border-left: solid #5cb70d;
  }
</style>


// WEBPACK FOOTER //
// src/components/montar_aposta/editar_aposta_sem_componente.vue